<template lang="pug">
  #hotsite(:class="tema")
    .placa
      .container
        .descricao: h3 {{ nome }}
    .corpo
      .container
        .row(style="display:flex")
          .col-xs-12.col-md-8.col-lg-9
            hotsite-menu(slot="mobile", :links="menu")
            breadcrumb.hotsite(:itens="breadcrumb")
            slot(name="conteudo")
          .col-md-4.col-lg-3.visible-md.visible-lg
            hotsite-aside(slot="sidebar", :links="menu")
    .links
      hotsite-links(slot="links", :links="links")
</template>

<style lang="scss">
  #hotsite {
    display: flex;
    flex: 1 1 auto;
    flex-wrap: wrap;
    flex-direction: column;
    min-height: 100%;
    height: 100%;

    > .placa {
      background-image: url('../../../static/banner_hotsite.jpg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      position: relative;
      @include media(">=phone","<tablet") { height: 150px }
      @include media(">=tablet","<desktop") { height: 250px }
      @include media(">=desktop") { height: 300px }
      &:before {
        position: absolute;
        opacity: 0.7;
        content: '';
        bottom: 0;
        right: 0;
        left: 0;
        top: 0;
      }
      > .container {
        min-height: 100%;
        height: inherit;
      }
    }

    > .corpo {
      min-height: calc(100vh - 876px);
      > .container, .row, .row > *, .lateral {
        min-height: inherit;
      }

      .conteudo {
        min-height: calc(100% - 97px) !important;
        height: calc(100% - 97px);

        ul {
          li {
            padding: 5px 0;

            &:before {
              content: "\f0da";
              font-family: FontAwesome;
              display: inline-block;
              width: 1em;
            }

            & > a:focus,
            & > a:visited,
            & > a:hover { color: $color-grey-dark }
          }
        }

        @include media(">=desktop") {
          min-height: 100% !important;
          height: 100%;
          margin-right: 25px;
        }
      }
    }

    .descricao {
      position: relative;
      height: inherit;
      > h3 {
        position: absolute;
        bottom: 30px;
        left: 0;
        background-color: #fff;
        border-radius: 7px;
        line-height: 30px;
        padding: 5px 11px;
        opacity: 0.7;
        color: inherit;
      }
    }

  }
</style>

<script>
  import HotsiteAside from 'COMPONENTS/HotsiteAside'
  import HotsiteMenu from 'COMPONENTS/HotsiteMenu'
  import HotsiteLinks from 'COMPONENTS/HotsiteLinks'
  import Breadcrumb from 'COMPONENTS/Breadcrumb'

  export default {
    name: 'hotsite',

    components: {
      HotsiteAside,
      HotsiteMenu,
      HotsiteLinks,
      Breadcrumb
    },

    props: {
      nome: { type: String, required: true },
      tema: { type: String, required: true },
      capa: { type: String, required: false },
      menu: { type: Array, required: true },
      links: { type: Array, required: true },
      breadcrumb: { type: Array, required: true }
    }
  }
</script>



// WEBPACK FOOTER //
// Hotsite.vue?9ed285ae